import React from 'react';
import PropTypes from 'prop-types';
import * as listIconStyles from '../../../styles/custom/list-icon.module.scss';

const ListIcon = ({ elem }) => {
  const { config } = elem;
  const { icons } = config;
  const titlePos = config.titlePos || 'DOWN';
  const isTitleUp = titlePos === 'UP';

  const isValidIconCode = (iconCode) => {
    try {
      return /^[0-9A-Fa-f]{4}$/.test(iconCode);
    } catch (e) {
      return false;
    }
  };

  const renderIcon = (iconCode) => {
    if (isValidIconCode(iconCode)) {
      return (
        <span className={listIconStyles.materialIcon}>
          {String.fromCodePoint(parseInt(iconCode, 16))}
        </span>
      );
    }
    return (
      <span className={listIconStyles.textIcon}>{iconCode}</span>
    );

  };

  const renderIconContent = (item) => (
    <>
      {isTitleUp && (
        <span className={listIconStyles.title}>{item.title}</span>
      )}
      <div className={listIconStyles.iconWrapper}>
        {renderIcon(item.icon)}
      </div>
      {!isTitleUp && (
        <span className={listIconStyles.title}>{item.title}</span>
      )}
    </>
  );

  return (
    <div className={listIconStyles.root}>
      <div className={listIconStyles.iconsContainer}>
        {icons.map((item) => {
          const hasValidHref = item.href && item.href.trim() !== '';

          return hasValidHref ? (
            <a
              aria-label={item.ariaLabel}
              className={`${listIconStyles.iconItem} ${listIconStyles.clickable}`}
              href={item.href}
              key={item.id}
              rel={item.newTab ? 'noopener noreferrer' : ''}
              target={item.newTab ? '_blank' : '_self'}
            >
              {renderIconContent(item)}
            </a>
          ) : (
            <div
              className={listIconStyles.iconItem}
              key={item.id}
            >
              {renderIconContent(item)}
            </div>
          );
        })}
      </div>
    </div>
  );
};

ListIcon.propTypes = {
  elem: PropTypes.shape({
    config: PropTypes.shape({
      titlePos: PropTypes.string,
      icons: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          icon: PropTypes.string.isRequired,
          href: PropTypes.string,
          ariaLabel: PropTypes.string,
          id: PropTypes.string.isRequired,
          newTab: PropTypes.bool
        })
      ).isRequired
    }).isRequired
  }).isRequired
};

export default ListIcon;